// extracted by mini-css-extract-plugin
export var aircallIframe = "_id-3";
export var fabContainer = "_id-5";
export var fabRinging = "_id-6";
export var loadingOverlay = "_id-4";
export var pulse = "_id-7";
export var widgetContent = "_id-2";
export var widgetPanel = "_id-0";
export var widgetPanelExpanded = "_id-1";